"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniqueCartDiscountTemplate = exports.uniqueCartTaxTemplate = void 0;
const uniqueCartTaxTemplate = (cartItem) => {
    return `${cartItem.percentage}_${cartItem.isTaxInclusive}`;
};
exports.uniqueCartTaxTemplate = uniqueCartTaxTemplate;
const uniqueCartDiscountTemplate = (discountItem) => {
    const discountPercentage = `${discountItem.percentage}` ?? '';
    return `${discountItem.discountId}_${discountItem.discount?.type}_${discountPercentage}_${discountItem.actionId}`;
};
exports.uniqueCartDiscountTemplate = uniqueCartDiscountTemplate;
//# sourceMappingURL=cart.consts.js.map